import { MuiTelInput } from 'mui-tel-input';
import { FC } from 'react';
import { useForm } from '@carcareers/contexts';

export interface PhoneInputProps {
  label: string;
  name: string;
  required?: boolean;
  autoComplete?: string;
  fullWidth?: boolean;
  disabled?: boolean;
}

export const PhoneInput: FC<PhoneInputProps> = ({
  label,
  name,  
  required,
  autoComplete,
  fullWidth,
  disabled,
}) => {
  const { setData, getData, getErrors } = useForm();

  const handleChange = (value: string) => setData(name, value);

  return (
    <MuiTelInput
      forceCallingCode
      name={name}
      required={required}
      fullWidth={fullWidth}
      defaultCountry={'US'}
      preferredCountries={['US']}
      value={getData<string>(name) ?? ''}
      label={label}
      autoComplete={autoComplete}
      onChange={(value) => handleChange(value)}
      error={!!getErrors(name)}
      helperText={getErrors(name)}
      disabled={disabled}
    />
  );
};

export default PhoneInput;
